import type { ComponentPropsWithoutRef } from "react";

import { tw } from "~/utils";

export const CheckIcon = ({
  className,
  ...props
}: ComponentPropsWithoutRef<"svg">) => (
  <svg
    className={tw("h-6 w-6 fill-inherit", className)}
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity={0.3}
      d="M32 63.9668C14.3452 63.9668 0.0331672 49.6548 0.0331664 32C0.0331657 14.3452 14.3452 0.033172 32 0.0331712C49.6548 0.0331704 63.9668 14.3452 63.9668 32C63.9668 49.6548 49.6548 63.9668 32 63.9668Z"
      fill="#AEC6B1"
      stroke="#7A5241"
      strokeWidth={0.0663357}
    />
    <path
      opacity={0.7}
      d="M32 52.9668C20.4203 52.9668 11.0332 43.5797 11.0332 32C11.0332 20.4203 20.4203 11.0332 32 11.0332C43.5797 11.0332 52.9668 20.4203 52.9668 32C52.9668 43.5797 43.5797 52.9668 32 52.9668Z"
      fill="#AEC6B1"
      stroke="#7A5241"
      strokeWidth={0.0663357}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.5754 26.0909C39.9395 26.4087 39.9769 26.9614 39.6591 27.3255L30.4925 37.8255C30.3263 38.0158 30.086 38.125 29.8333 38.125C29.5806 38.125 29.3403 38.0158 29.1742 37.8255L25.5075 33.6255C25.1897 33.2614 25.2271 32.7087 25.5912 32.3909C25.9552 32.073 26.508 32.1105 26.8258 32.4746L29.8333 35.9195L38.3408 26.1746C38.6586 25.8105 39.2114 25.773 39.5754 26.0909Z"
      fill="#262608"
    />
  </svg>
);
